module.exports = "/assets/site/images/logo_fehér.png?4ab04988cba2d80428d7a83b3beb3151";